export enum CharacterSocket {
  LeftHand = 'left_hand_socket',
  RightHand = 'right_hand_socket',
}

